module.exports = __webpack_public_path__ + "img/portrait-005.12e89285.jpg";